import {
  type RouteRecordRaw,
  type RouteRecordRedirectOption,
  type RouteComponent,
} from 'vue-router';
import polisdetailsRoutes from './polisdetails.routes';

const fullPageTitle = (tabName: string) => `Relatiegegevens - ${tabName}`;

const createRoute = (
  tabName: string,
  icon: string,
  component: RouteComponent,
  options?: {
    pageTitle?: string;
    children?: RouteRecordRaw[];
    extraWidth?: boolean;
    redirect?: RouteRecordRedirectOption;
  },
): RouteRecordRaw => {
  const capitalisedName =
    tabName[0].toUpperCase() + tabName.slice(1).replace(/-([a-zA-Z])/g, (_, x) => x.toUpperCase());

  return {
    path: tabName,
    redirect: options?.redirect,
    name: tabName,
    props: (route) => ({
      relatienummer: Number.parseInt(route.params.relatienummer as string, 10),
    }),
    meta: {
      title: fullPageTitle(options?.pageTitle || capitalisedName),
      label: options?.pageTitle || capitalisedName,
      icon,
      extraWidth: options?.extraWidth ?? false,
    },
    children: options?.children ?? [],
    component,
  };
};

const markDefault = (route: RouteRecordRaw): RouteRecordRaw => {
  route.meta = route.meta || {};
  route.meta.default = true;
  return route;
};

const routes: RouteRecordRaw[] = [
  markDefault(
    createRoute(
      'algemeen',
      'fa-bars',
      () => import(`../relatiegegevens/tabs/RelatiegegevensAlgemeen.page.vue`),
      {
        extraWidth: true,
      },
    ),
  ),
  createRoute(
    'UBO',
    'fa-user-group',
    () => import('../relatiegegevens/tabs/RelatiegegevensUbo.page.vue'),
  ),
  createRoute(
    'offertes',
    'fa-calculator',
    () => import(`../relatiegegevens/tabs/RelatiegegevensOffertes.page.vue`),
  ),
  createRoute(
    'aanvragen',
    'fa-file-contract',
    () => import(`../relatiegegevens/tabs/RelatiegegevensAanvragen.page.vue`),
  ),
  createRoute(
    'polissen',
    'fa-check-double',
    () => import(`../relatiegegevens/tabs/RelatiegegevensPolissen.page.vue`),
    {
      redirect: { name: 'polisoverzicht' },
      children: [
        {
          name: 'polisoverzicht',
          path: '',
          component: () =>
            import('../relatiegegevens/tabs/RelatiegegevensPolissenContent.page.vue'),
          props: true,
        },
        {
          name: 'polisdetails',
          path: ':polisnummer',
          children: polisdetailsRoutes,
          component: () => import('../Polissen/details/PolisdetailsLayout.vue'),
          props: true,
        },
      ],
    },
  ),
  createRoute(
    'schades',
    'fa-car-burst',
    () => import(`../relatiegegevens/tabs/RelatiegegevensSchades.page.vue`),
  ),
  createRoute(
    'incasso',
    'fa-money-check-dollar-pen',
    () => import(`../relatiegegevens/tabs/RelatiegegevensIncasso.page.vue`),
  ),
  createRoute(
    'alerts',
    'fa-bell',
    () => import(`../relatiegegevens/tabs/RelatiegegevensAlerts.page.vue`),
    {
      pageTitle: 'Alerts',
    },
  ),
  createRoute(
    'documenten',
    'fa-files',
    () => import(`../relatiegegevens/tabs/RelatiegegevensDocumenten.page.vue`),
    {
      extraWidth: true,
    },
  ),
  createRoute(
    'prolongatiewijzigingen',
    'fa-rectangle-history-circle-user',
    () =>
      import(
        `../relatiegegevens/tabs/RelatiegegevensProlongatiewijzigingen.page/RelatiegegevensProlongatiewijzigingen.page.vue`
      ),
  ),
  createRoute(
    'memos',
    'fa-memo',
    () => import(`../relatiegegevens/tabs/RelatiegegevensMemos.page.vue`),
  ),
  createRoute(
    'naselectie',
    'fa-user-plus',
    () => import(`../relatiegegevens/tabs/RelatiegegevensNaselectie.page.vue`),
  ),
];

export default routes;
